// extracted by mini-css-extract-plugin
module.exports = {"forkIcon":"ForkProducts_forkIcon__3Lmt5","title":"ForkProducts_title__1odXS","popover":"ForkProducts_popover__9jcf-"};